(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-greeting-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('cart-greeting-card')) return;
    const states = new Map();
    let queue = Promise.resolve();
    let replaying = false;
    const pendingForms = new WeakSet();
    const save = (payload) => {
      const snapshot = { attributes: { ...payload.attributes }, instruction: payload.instruction };
      if (payload.clearLegacyCardHandle) snapshot.attributes['Card Handle'] = '';
      queue = queue.catch(() => {}).then(async () => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: snapshot.attributes, note: snapshot.instruction }), signal: controller.signal
          });
          if (!response.ok) throw new Error('Greeting card save failed');
          return response.json();
        } finally { clearTimeout(timeout); }
      });
      return queue;
    };
    class CartGreetingCard extends HTMLElement {
      connectedCallback() {
        if (this.ready) { this.resizeObserver?.observe(this.track); return; }
        if (!this.querySelector('[data-bgg-toggle]')) {
          if (this.isConnected) requestAnimationFrame(() => this.connectedCallback());
          return;
        }
        this.toggle = this.querySelector('[data-bgg-toggle]');
        this.body = this.querySelector('[data-bgg-body]');
        this.track = this.querySelector('[data-bgg-track]');
        this.fields = Array.from(this.querySelectorAll('[data-bgg-attribute]'));
        this.instruction = this.querySelector('[data-bgg-instruction]');
        this.cards = Array.from(this.querySelectorAll('[data-bgg-card]'));
        this.error = this.querySelector('[data-bgg-error]');
        if (!this.toggle || !this.body || !this.cards.length) return;
        this.ready = true;
        const local = states.get(this.dataset.stateKey);
        if (local) {
          this.toggle.checked = local['Greeting Card'] === 'Yes';
          this.fields.forEach(field => { field.value = local[field.dataset.bggAttribute] || ''; });
          this.instruction.value = local.__instruction || '';
        }
        const savedImage = this.fields.find(field => field.dataset.bggAttribute === 'Card Image').value;
        const savedTitle = this.fields.find(field => field.dataset.bggAttribute === 'Greeting_Card').value;
        const selected = this.cards.find(card => savedImage && card.dataset.image === savedImage)
          || this.cards.find(card => card.checked)
          || this.cards.find(card => savedTitle && card.dataset.title === savedTitle)
          || this.cards[0];
        selected.checked = true;
        this.sync(false);
        if (this.dataset.legacyInstructions === 'true' || this.dataset.legacyCardHandle === 'true') this.persist();
        this.addEventListener('input', event => {
          if (!event.target.matches('[data-bgg-attribute], [data-bgg-instruction]')) return;
          event.stopPropagation();
          this.sync(true);
        });
        this.addEventListener('change', event => {
          if (!event.target.matches('[data-bgg-toggle], [data-bgg-card], [data-bgg-attribute], [data-bgg-instruction]')) return;
          event.stopPropagation();
          this.sync(true);
          if (event.target.matches('[data-bgg-toggle], [data-bgg-card]')) this.persist();
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Enter' && event.target.matches('input[type="text"], input[type="tel"]')) event.preventDefault();
        });
        this.querySelector('[data-bgg-prev]').addEventListener('click', () => this.scroll(-1));
        this.querySelector('[data-bgg-next]').addEventListener('click', () => this.scroll(1));
        this.track.addEventListener('scroll', () => this.arrows(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.arrows());
        this.resizeObserver.observe(this.track);
        this.arrows();
        if (local) selected.closest('.bgg-card').scrollIntoView({ block:'nearest', inline:'nearest' });
      }
      disconnectedCallback() { this.resizeObserver?.disconnect(); }
      attributesPayload() {
        return Object.fromEntries(this.fields.map(field => [field.dataset.bggAttribute, this.toggle.checked ? field.value : '']));
      }
      savePayload() {
        return {
          attributes: this.attributesPayload(),
          instruction: this.toggle.checked ? this.instruction.value : '',
          clearLegacyCardHandle: this.dataset.legacyCardHandle === 'true'
        };
      }
      sync(changed) {
        const enabled = this.toggle.checked;
        this.body.hidden = !enabled;
        this.body.disabled = !enabled;
        this.toggle.setAttribute('aria-expanded', String(enabled));
        const selected = this.cards.find(card => card.checked) || this.cards[0];
        this.fields.forEach(field => {
          const key = field.dataset.bggAttribute;
          if (key === 'Greeting Card') field.value = enabled ? 'Yes' : '';
          if (key === 'Greeting_Card') field.value = enabled ? selected.dataset.title : '';
          if (key === 'Card Image') field.value = enabled ? selected.dataset.image : '';
          if (!enabled && field.type !== 'hidden') field.value = '';
        });
        if (!enabled) this.instruction.value = '';
        const message = this.fields.find(field => field.dataset.bggAttribute === 'Card_Message');
        message.value = message.value.slice(0, 300);
        this.querySelector('[data-bgg-count]').textContent = message.value.length;
        if (changed) {
          const payload = this.attributesPayload();
          states.set(this.dataset.stateKey, { ...payload, __instruction: this.instruction.value });
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.persist(), 400);
        }
        requestAnimationFrame(() => this.arrows());
      }
      async persist() {
        clearTimeout(this.timer);
        this.error.hidden = true;
        try {
          const cart = await save(this.savePayload());
          if (!cart.attributes?.['Card Handle']) this.dataset.legacyCardHandle = 'false';
        } catch (error) { this.showError(); }
      }
      showError() { this.error.textContent = this.dataset.error; this.error.hidden = false; }
      scroll(direction) { this.track.scrollBy({ left: direction * 118, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
      arrows() {
        const remaining = this.track.scrollWidth - this.track.clientWidth;
        this.querySelector('[data-bgg-prev]').disabled = this.track.scrollLeft <= 1;
        this.querySelector('[data-bgg-next]').disabled = this.track.scrollLeft >= remaining - 1;
      }
    }
    customElements.define('cart-greeting-card', CartGreetingCard);
    async function guardCheckout(event, form, button, resume) {
      const component = form?.querySelector('cart-greeting-card');
      if (!component?.ready || replaying) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (pendingForms.has(form)) return;
      pendingForms.add(form);
      clearTimeout(component.timer);
      component.error.hidden = true;
      button?.setAttribute('aria-busy', 'true');
      try {
        let snapshot;
        do {
          snapshot = component.savePayload();
          await save(snapshot);
        } while (JSON.stringify(snapshot) !== JSON.stringify(component.savePayload()));
        replaying = true;
        try { resume(); } finally { replaying = false; }
      } catch (error) { component.showError(); component.error.scrollIntoView({ block: 'nearest' }); }
      finally { pendingForms.delete(form); button?.removeAttribute('aria-busy'); }
    }
    document.addEventListener('click', event => {
      const button = event.target.closest('button[name="checkout"], input[name="checkout"], a[href]');
      if (!button) return;
      const form = button.closest('form[data-cart-content]');
      const link = button.tagName === 'A' && /\/checkout(?:[/?#]|$)/.test(button.getAttribute('href'));
      if (button.tagName === 'A' && !link) return;
      guardCheckout(event, form, button, () => button.click());
    }, true);
    document.addEventListener('submit', event => {
      if (event.submitter?.name !== 'checkout') return;
      guardCheckout(event, event.target, event.submitter, () => event.target.requestSubmit(event.submitter));
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-send-as-gift"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('cart-send-as-gift')) return;
    const states = new Map();
    const saved = new Map();
    const pendingForms = new WeakSet();
    let queue = Promise.resolve();
    let pendingSaves = 0;
    const save = (key, attributes) => {
      const snapshot = { ...attributes };
      pendingSaves++;
      queue = queue.catch(() => {}).then(async () => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/update.js', {
            method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
            body:JSON.stringify({ attributes:snapshot }), signal:controller.signal
          });
          if (!response.ok) throw new Error('Gift details save failed');
          await response.json();
          saved.set(key, JSON.stringify(snapshot));
        } finally { clearTimeout(timeout); pendingSaves--; }
      });
      return queue;
    };
    class CartSendAsGift extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        if (!this.querySelector('[data-csg-toggle]')) {
          if (this.isConnected) requestAnimationFrame(() => this.connectedCallback());
          return;
        }
        this.toggle = this.querySelector('[data-csg-toggle]');
        this.body = this.querySelector('[data-csg-body]');
        this.multiple = this.querySelector('[data-csg-multiple]');
        this.multipleNote = this.querySelector('[data-csg-multiple-note]');
        this.fields = Array.from(this.querySelectorAll('[data-csg-attribute]'));
        this.error = this.querySelector('[data-csg-error]');
        this.ready = true;
        const local = states.get(this.dataset.stateKey);
        if (local) {
          this.toggle.checked = local['Sending as a Gift'] === 'true';
          this.multiple.checked = local['Send to Multiple Addresses'] === 'true';
          this.fields.forEach(field => { field.value = local[field.dataset.csgAttribute] || ''; });
        }
        this.sync(false);
        this.addEventListener('input', event => {
          if (!event.target.matches('[data-csg-attribute]')) return;
          event.stopPropagation();
          this.sync(true);
        });
        this.addEventListener('change', event => {
          if (!event.target.matches('[data-csg-toggle], [data-csg-multiple], [data-csg-attribute]')) return;
          event.stopPropagation();
          this.sync(true);
          if (event.target.matches('[data-csg-toggle], [data-csg-multiple]')) this.persist();
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Enter' && event.target.matches('input[type="text"], input[type="tel"], input[type="email"]')) event.preventDefault();
        });
      }
      attributesPayload() {
        return Object.fromEntries(this.fields.map(field => [field.dataset.csgAttribute, field.value]));
      }
      sync(changed) {
        const enabled = this.toggle.checked;
        this.body.hidden = !enabled;
        this.body.disabled = !enabled;
        this.toggle.setAttribute('aria-expanded', String(enabled));
        if (!enabled) this.multiple.checked = false;
        this.multipleNote.hidden = !enabled || !this.multiple.checked;
        this.fields.forEach(field => {
          const key = field.dataset.csgAttribute;
          if (key === 'Sending as a Gift') field.value = String(enabled);
          else if (key === 'Send to Multiple Addresses') field.value = String(enabled && this.multiple.checked);
          else if (!enabled) field.value = '';
        });
        if (changed) {
          states.set(this.dataset.stateKey, this.attributesPayload());
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.persist(), 400);
        }
      }
      async persist() {
        clearTimeout(this.timer);
        this.error.hidden = true;
        try { await save(this.dataset.stateKey, this.attributesPayload()); }
        catch (error) { this.showError(); }
      }
      showError() { this.error.hidden = false; }
    }
    customElements.define('cart-send-as-gift', CartSendAsGift);
    async function guardCheckout(event, form, button, resume) {
      let component = form?.querySelector('cart-send-as-gift');
      if (!component?.ready) return;
      component.sync(false);
      if (!pendingSaves && saved.get(component.dataset.stateKey) === JSON.stringify(component.attributesPayload())) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (pendingForms.has(form)) return;
      pendingForms.add(form);
      button?.setAttribute('aria-busy', 'true');
      try {
        do {
          component = form.querySelector('cart-send-as-gift');
          if (!component?.ready) throw new Error('Gift form was replaced');
          clearTimeout(component.timer);
          component.sync(false);
          component.error.hidden = true;
          await save(component.dataset.stateKey, component.attributesPayload());
          component = form.querySelector('cart-send-as-gift');
        } while (component?.ready && (pendingSaves || saved.get(component.dataset.stateKey) !== JSON.stringify(component.attributesPayload())));
        if (!component?.ready || !form.isConnected) throw new Error('Gift form was replaced');
        clearTimeout(component.timer);
        resume();
      } catch (error) {
        component?.showError();
        component?.error?.scrollIntoView({ block:'nearest' });
      } finally { pendingForms.delete(form); button?.removeAttribute('aria-busy'); }
    }
    window.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('button[name="checkout"], input[name="checkout"], a[href]');
      if (!button) return;
      if (button.tagName === 'A' && !/\/checkout(?:[/?#]|$)/.test(button.getAttribute('href'))) return;
      const form = button.closest('form[data-cart-content]');
      guardCheckout(event, form, button, () => button.click());
    }, true);
    window.addEventListener('submit', event => {
      if (event.submitter?.name !== 'checkout') return;
      guardCheckout(event, event.target, event.submitter, () => event.target.requestSubmit(event.submitter));
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
